import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

export const useTracking = () => {
  const {track, page} = useAnalyticsTrack()

  const pageViewed = () =>
    page({
      event: 'Page Viewed',
      data: {
        page_name: 'unsubscribe_landing',
        channel: 'account',
        page_type: 'form',
        page_category_level1: 'unsubscribe'
      }
    })

  const trackButtonClicked = (portalAnnouncements, externalServicesOffers) =>
    track({
      event: 'Landing Unsubscribed Button Clicked',
      // PORTAL_ANNOUNCEMENTS: hit_information, EXTERNAL_SERVICES_OFFERS: hit_information2
      data: {hit_information: portalAnnouncements, hit_information2: externalServicesOffers}
    })

  const trackLinkClicked = () =>
    track({
      event: 'Landing Manage Subscription Clicked'
    })

  const trackRadioButtonsFormClicked = (selectedOption, otherReason = '') =>
    track({
      event: 'Landing Unsubscribed Reason Clicked',
      data: {hit_information: selectedOption, hit_information2: otherReason}
    })

  const successPageViewed = () =>
    page({
      event: 'Page Viewed',
      data: {
        page_name: 'unsubscribe_landing_finalized',
        channel: 'account',
        page_type: 'form',
        page_category_level1: 'unsubscribe'
      }
    })

  return {
    pageViewed,
    successPageViewed,
    trackButtonClicked,
    trackLinkClicked,
    trackRadioButtonsFormClicked
  }
}
